<template>
    <div>
        <DTabs class="mb-3">
            <DTabItem
                id="compensation-rates"
                :active="['tools.partners.partner-compensation-rates.index'].includes($route().current())"
                :label="__('tools.partners.tabs.compensation_rates')"
                :route-url="$route('tools.partners.partner-compensation-rates.index')"
            />
            <DTabItem
                id="uploads"
                :active="['tools.partners.partner-uploads.index'].includes($route().current())"
                :label="__('tools.partners.tabs.uploads')"
                :route-url="$route('tools.partners.partner-uploads.index')"
            />
            <DTabItem
                id="contracts"
                :active="['tools.partners.contracts.index'].includes($route().current())"
                :label="__('tools.partners.tabs.contracts')"
                :route-url="$route('tools.partners.contracts.index')"
            />
        </DTabs>

        <CompensationRateIndex
            v-if="['tools.partners.partner-compensation-rates.index'].includes($route().current())"
            :compensation-rates="compensationRates"
        />
        <UploadIndex
            v-if="['tools.partners.partner-uploads.index'].includes($route().current())"
            :uploads="uploads"
            :invoicing-running="invoicingRunning"
        />
        <ContractsIndex
            v-if="['tools.partners.contracts.index'].includes($route().current())"
            :contracts="contracts"
        />
    </div>
</template>

<script>
import CompensationRateIndex from '~@/Components/Tools/Partners/CompensationRates/Index'
import UploadIndex from '~@/Components/Tools/Partners/Uploads/Index'
import ContractsIndex from '~@/Components/Tools/Partners/Contracts/Index'

export default {
    name: 'PartnerTabs',
    components: {
        UploadIndex,
        CompensationRateIndex,
        ContractsIndex
    },
    props: {
        tab: {
            type: String,
            default: ''
        },
        compensationRates: {
            type: Object,
            default: () => { return {} }
        },
        uploads: {
            type: Object,
            default: () => { return {} }
        },
        contracts: {
            type: Object,
            default: () => { return {} }
        },
        invoicingRunning: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    }
}
</script>

<style scoped>

</style>
